var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitchTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 134,
    viewBox: "0 0 192 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 191,
    height: 133,
    rx: 10.5,
    stroke: "#EAEFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_218_132",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 190,
    height: 132
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 190,
    height: 132,
    rx: 10,
    fill: "url(#paint0_linear_218_132)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_218_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6.7561C1 3.5771 3.57709 1 6.7561 1H349.244C352.423 1 355 3.57709 355 6.7561V252.829C355 256.008 352.423 258.585 349.244 258.585H6.75609C3.57709 258.585 1 256.008 1 252.829V6.7561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6.7561C1 3.5771 3.57709 1 6.7561 1H23.5447V258.585H6.7561C3.57709 258.585 1 256.008 1 252.829V6.7561Z",
    fill: "#EAEFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.968 19.9635C343.968 20.3609 343.645 20.683 343.248 20.683H30.9798C30.5824 20.683 30.2603 20.3609 30.2603 19.9635C30.2603 19.5661 30.5824 19.244 30.9798 19.244H343.248C343.645 19.244 343.968 19.5661 343.968 19.9635Z",
    fill: "#EAEFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7803 11.8089C29.7803 11.0141 30.4245 10.3698 31.2193 10.3698H56.6421C57.4368 10.3698 58.0811 11.0141 58.0811 11.8089C58.0811 12.6036 57.4368 13.2479 56.6421 13.2479H31.2193C30.4245 13.2479 29.7803 12.6036 29.7803 11.8089Z",
    fill: "#C3D1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3671 9.60604C12.0532 9.60604 12.6093 9.05475 12.6093 8.37471C12.6093 7.69467 12.0532 7.14338 11.3671 7.14338C10.6811 7.14338 10.125 7.69467 10.125 8.37471C10.125 9.05475 10.6811 9.60604 11.3671 9.60604Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.125 13.3C10.811 13.3 11.3671 12.7487 11.3671 12.0687C11.3671 11.3886 10.811 10.8374 10.125 10.8374C9.43894 10.8374 8.8828 11.3886 8.8828 12.0687C8.8828 12.7487 9.43894 13.3 10.125 13.3Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8828 16.994C9.56883 16.994 10.125 16.4427 10.125 15.7627C10.125 15.0826 9.56883 14.5313 8.8828 14.5313C8.19677 14.5313 7.64062 15.0826 7.64062 15.7627C7.64062 16.4427 8.19677 16.994 8.8828 16.994Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3358 9.60604C17.0219 9.60604 17.578 9.05475 17.578 8.37471C17.578 7.69467 17.0219 7.14338 16.3358 7.14338C15.6498 7.14338 15.0937 7.69467 15.0937 8.37471C15.0937 9.05475 15.6498 9.60604 16.3358 9.60604Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0937 13.3C15.7797 13.3 16.3358 12.7487 16.3358 12.0687C16.3358 11.3886 15.7797 10.8374 15.0937 10.8374C14.4076 10.8374 13.8515 11.3886 13.8515 12.0687C13.8515 12.7487 14.4076 13.3 15.0937 13.3Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8515 16.994C14.5375 16.994 15.0937 16.4427 15.0937 15.7627C15.0937 15.0826 14.5375 14.5313 13.8515 14.5313C13.1655 14.5313 12.6093 15.0826 12.6093 15.7627C12.6093 16.4427 13.1655 16.994 13.8515 16.994Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4914 8.00531C11.2844 7.92322 11.0773 8.04637 10.9945 8.25159L10.3734 10.0986C10.2906 10.3038 10.4148 10.509 10.6218 10.5911C10.8289 10.6732 11.0359 10.5501 11.1187 10.3448L11.7398 8.49785C11.8226 8.29262 11.6984 8.0874 11.4914 8.00531Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5968 13.5053C14.3898 13.4232 14.1827 13.5463 14.0999 13.7515L13.4788 15.5985C13.396 15.8037 13.5202 16.0089 13.7273 16.091C13.9343 16.1731 14.1414 16.05 14.2242 15.8448L14.8453 13.9978C14.9281 13.7926 14.8039 13.5873 14.5968 13.5053Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75232 11.9456C9.83513 11.7404 10.0422 11.6172 10.2492 11.6993C10.4563 11.7814 10.5805 11.9866 10.4976 12.1918L9.25547 15.8858C9.17266 16.091 8.9656 16.2142 8.75857 16.1321C8.55154 16.05 8.42734 15.8448 8.51015 15.6396L9.75232 11.9456Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9632 8.25159C16.046 8.04637 16.2531 7.92322 16.4601 8.00531C16.6671 8.0874 16.7913 8.29262 16.7085 8.49785L15.4663 12.1918C15.3835 12.397 15.1765 12.5202 14.9694 12.4381C14.7624 12.356 14.6382 12.1508 14.721 11.9456L15.9632 8.25159Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6569 8.0874C11.4913 7.92322 11.2429 7.92322 11.1187 8.0874C10.9531 8.25158 10.9531 8.49784 11.1187 8.62097L14.8452 12.315C15.0108 12.4791 15.2592 12.4791 15.3835 12.315C15.5491 12.1508 15.5491 11.9045 15.3835 11.7814L11.6569 8.0874Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4148 11.7814C10.2491 11.6172 10.0007 11.6172 9.87653 11.7814C9.7109 11.9456 9.7109 12.1918 9.87653 12.315L13.603 16.0089C13.7687 16.1731 14.0171 16.1731 14.1413 16.0089C14.3069 15.8448 14.3069 15.5985 14.1413 15.4754L10.4148 11.7814Z",
    fill: "#546FFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68,
    cy: 50.5,
    rx: 13,
    ry: 13.5,
    stroke: "#546FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "2 4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.0548,
    cy: 88.0548,
    r: 14.0548,
    fill: "#E280DE",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.055,
    cy: 50.0548,
    r: 14.0548,
    fill: "#8475F6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.055,
    cy: 88.0548,
    r: 14.0548,
    fill: "#F39762",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.055,
    cy: 50.0548,
    r: 14.0548,
    fill: "#75D1EE",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.055,
    cy: 88.0548,
    r: 14.0548,
    fill: "#41A451",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6953 92V84H66.3867V87.3008H69.8203V84H71.5078V92H69.8203V88.6953H66.3867V92H64.6953Z",
    fill: "#E280DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.035 48.3008C107.004 47.9857 106.87 47.7409 106.633 47.5664C106.396 47.3919 106.074 47.3047 105.668 47.3047C105.392 47.3047 105.159 47.3437 104.969 47.4219C104.779 47.4974 104.633 47.6029 104.531 47.7383C104.432 47.8737 104.383 48.0273 104.383 48.1992C104.378 48.3424 104.408 48.4674 104.473 48.5742C104.54 48.681 104.633 48.7734 104.75 48.8516C104.867 48.9271 105.003 48.9935 105.156 49.0508C105.31 49.1055 105.474 49.1523 105.648 49.1914L106.367 49.3633C106.716 49.4414 107.036 49.5456 107.328 49.6758C107.62 49.806 107.872 49.9661 108.086 50.1562C108.299 50.3464 108.465 50.5703 108.582 50.8281C108.702 51.0859 108.763 51.3815 108.766 51.7148C108.763 52.2044 108.638 52.6289 108.391 52.9883C108.146 53.3451 107.792 53.6224 107.328 53.8203C106.867 54.0156 106.311 54.1133 105.66 54.1133C105.014 54.1133 104.452 54.0143 103.973 53.8164C103.496 53.6185 103.124 53.3255 102.855 52.9375C102.59 52.5469 102.451 52.0638 102.437 51.4883H104.074C104.092 51.7565 104.169 51.9805 104.305 52.1602C104.443 52.3372 104.626 52.4714 104.855 52.5625C105.087 52.651 105.349 52.6953 105.641 52.6953C105.927 52.6953 106.176 52.6536 106.387 52.5703C106.6 52.487 106.766 52.3711 106.883 52.2227C107 52.0742 107.059 51.9036 107.059 51.7109C107.059 51.5312 107.005 51.3802 106.898 51.2578C106.794 51.1354 106.641 51.0312 106.438 50.9453C106.237 50.8594 105.991 50.7812 105.699 50.7109L104.828 50.4922C104.154 50.3281 103.621 50.0716 103.23 49.7227C102.84 49.3737 102.646 48.9036 102.648 48.3125C102.646 47.8281 102.775 47.4049 103.035 47.043C103.298 46.681 103.659 46.3984 104.117 46.1953C104.576 45.9922 105.096 45.8906 105.68 45.8906C106.273 45.8906 106.792 45.9922 107.234 46.1953C107.68 46.3984 108.026 46.681 108.273 47.043C108.521 47.4049 108.648 47.8242 108.656 48.3008H107.035Z",
    fill: "#8475F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.695 92V84H109.086V85.3945H105.387V87.3008H108.809V88.6953H105.387V90.6055H109.102V92H103.695Z",
    fill: "#F39762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.695 54V46H143.387V49.5273H143.492L146.371 46H148.398L145.43 49.582L148.434 54H146.41L144.219 50.7109L143.387 51.7266V54H141.695Z",
    fill: "#75D1EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.387 84V92H146.926L143.445 86.9648H143.387V92H141.695V84H143.18L146.633 89.0312H146.703V84H148.387Z",
    fill: "#41A451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 46V54.5",
    stroke: "#546FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 50L64 50",
    stroke: "#546FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_218_132)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 66,
    r: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 66,
    r: 14,
    fill: "#5E64FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6953 70V62H49.3867V68.6055H52.8164V70H47.6953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 189,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 58 117)",
    fill: "url(#paint1_linear_218_132)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_218_132",
    x: 22,
    y: 42,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.588235 0 0 0 0 0.678431 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_218_132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_218_132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_218_132",
    x1: 116,
    y1: -24.3393,
    x2: -68.1147,
    y2: -38.7655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_218_132",
    x1: 94.1923,
    y1: 102.214,
    x2: 5.96154,
    y2: 102.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEBEFF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchTeam);
export default __webpack_public_path__ + "static/media/switch-team.3254290a3d0fd29b8e5e6c82a24c8258.svg";
export { ForwardRef as ReactComponent };